<div class="modal-header">
  <h5 class="modal-title" id="checkoutModalLabel"><i class="fas fa-shopping-cart"></i> Biểu Mẫu Mượn Sách</h5>
  <button type="button" class="close" data-dismiss="modal" aria-label="Đóng" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Nội Dung Modal (Biểu Mẫu) -->
<div class="modal-body">
  <form [formGroup]="checkoutForm">
    <!-- Chọn Thành Viên -->
    <div class="form-group">
      <label for="member">Thành Viên:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn thành viên mượn sách."></i>
      <ng-select  id="member" name="member"
                 [items]="members$"
                 bindLabel="firstname" bindValue="id"
                 formControlName="member"
                 placeholder="Chọn thành viên"
                 >
      </ng-select>
    </div>

    <!-- Mã Vạch Sách -->
    <div class="form-group">
      <label for="itemBarcode">Mã Vạch Sách:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn mã vạch của sách muốn mượn."></i>
      <ng-select  id="itemBarcode" name="itemBarcode"
                 [items]="books$"
                 bindLabel="title" bindValue="id"
                 formControlName="itemBarcode"
                 placeholder="Chọn mã vạch"
                 >
      </ng-select>
    </div>

    <!-- Ngày Đến Hạn -->
    <div class="form-group">
      <label for="dueDate">Ngày Đến Hạn (MM/DD/YYYY):</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Nhập ngày đến hạn trả sách."></i>
      <input type="date" class="form-control" id="dueDate" name="dueDate" formControlName="dueDate">
    </div>

    <!-- Gia Hạn Tự Động -->
    <div class="form-group">
      <label>Gia Hạn Tự Động:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn xem sách có được gia hạn tự động khi hết hạn không."></i>
      <div class="form-check">
        <input class="form-check-input" type="radio" name="automaticRenewal" id="automaticRenewalYes" value="yes" formControlName="automaticRenewal">
        <label class="form-check-label" for="automaticRenewalYes">Có</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" name="automaticRenewal" id="automaticRenewalNo" value="no" formControlName="automaticRenewal">
        <label class="form-check-label" for="automaticRenewalNo">Không</label>
      </div>
    </div>
  </form>
</div>

<!-- Chân Modal -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Đóng</button>
  <button type="button" class="btn btn-outline-primary" (click)="add()">Mượn Sách</button>
</div>
